import React from 'react'
import Header from '../components/header/header.component'
import Footer from '../components/footer/footer.component'
import AdContainer from '../components/ad/ad.container'
import SearchResultsContainer from '../components/search-results/search-results.container'
import SearchFilterContainer from '../components/search-filter/search-filter.container'
import FeaturedOutfittersContainer from '../components/featured-outfitters/featured-outfitters.container'

interface SerachScreenProps {
  title?: string
}

const SearchScreen: React.FC<SerachScreenProps> = () => {
  return (
    <div>
      <Header />
      <section />
      <div className='container'>
        <div className='row'>
          <div className='col-md-4'>
            <SearchFilterContainer />
            <AdContainer type='vertical' />
            <AdContainer type='square' />
          </div>
          <div className='col-md-8'>
            <SearchResultsContainer />
          </div>
        </div>
      </div>
      <FeaturedOutfittersContainer size='small' />
      <Footer />
    </div>
  )
}

export default SearchScreen
